import { RouteName, RoutePath, ScreenName } from '@helpcenter/constants';
import type { PaperAppearance } from 'view/layout/paper';
import { csmRequestDetailsQueryResource } from '@atlassian/csm-request-details/src/services/cms-request-details-resource';
import { mediaReadCredentialsResource } from '@atlassian/csm-request-details/src/services/media-read-credentials-resource';
import { mediaUploadCredentialsResource } from '@atlassian/csm-request-details/src/services/media-upload-credentials-resource';
import { requestConversationResource } from '@atlassian/csm-request-details/src/services/request-conversation-resource';
import { AsyncCsmRequestDetails } from '@atlassian/csm-request-details/src/ui/index';
import { CsmRequestsList } from '@atlassian/csm-requests-list';
import { csmRequestsListQueryResource } from '@atlassian/csm-requests-list/src/services/csm-requests-list-resource';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';

export const csmRequestsListRoute = createRouteWithLayout(
    {
        name: RouteName.CSM_REQUESTS_LIST_PAGE,
        path: RoutePath.CSM_REQUESTS_LIST_PATH,
        exact: true,
        component: CsmRequestsList,
        resources: [csmRequestsListQueryResource],
    },
    ScreenName.CSM_REQUESTS_LIST,
    {
        isAnonymous: false,
        paperAppearance: 'xxwide' as PaperAppearance,
        fadeInSearchModal: true,
        prefetchBrandingModel: true,
    }
);

export const csmRequestDetailsRoute = createRouteWithLayout(
    {
        name: RouteName.CSM_REQUEST_DETAILS_PAGE,
        path: RoutePath.CSM_REQUEST_DETAILS_PATH,
        exact: true,
        component: AsyncCsmRequestDetails,
        resources: [
            csmRequestDetailsQueryResource,
            requestConversationResource,
            mediaReadCredentialsResource,
            mediaUploadCredentialsResource,
        ],
    },
    ScreenName.CSM_REQUEST_DETAILS,
    {
        isAnonymous: false,
        paperAppearance: 'xxwide' as PaperAppearance,
        fadeInSearchModal: true,
        prefetchBrandingModel: true,
        hideBanner: true,
    }
);
